import { SET_QUESTIONS_DATA, SET_SURVEY_DATA, SET_SURVEY_RESPONSE_DATA } from "../ActionName/ActionName";

const initialState = {
    response: [],
    questions: [{}],
    selectedSurvey: null
}
const CreateSurvey = (state = initialState, action) => {
    switch (action.type) {
        case SET_QUESTIONS_DATA:
            return ({ ...state, questions: action.value, timestamp: Date.now() })
        case SET_SURVEY_RESPONSE_DATA:
            return ({ ...state, response: action.value, timestamp: Date.now() })
        case SET_SURVEY_DATA:
            return ({ ...state, selectedSurvey: action.value, timestamp: Date.now() })
        default:
            return state;
    }
}
export default CreateSurvey;